import React, { useState, useEffect } from "react";
import 'react-querybuilder/dist/query-builder.css';
import "./siteUrl.css";
import {
  Alert,
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  Button
} from "reactstrap";

import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import axiosInstance from "components/Common/ApiManagement/axiosInstance";
import { ApiNames } from "components/Common/ApiManagement/apiServices";
import { useNavigate, useParams } from "react-router-dom";
import ScanNameReports from "./scanNameReports";
import IndividualReports from "./individualReports";
import { PAGEPATHS, SIDEBARDATA, USERTYPES } from "components/Common/Constant";
import { useSelector } from "react-redux";

const fallbackOrder = ["scanName", "category", "scanSubcat", "scanGroup", "areaName"];

const CustomerDashboard = props => {
  document.title = "Add Site URL's";

  const { scanId } = useParams();
  const navigate = useNavigate();

  const [reportsData, setReportsData] = useState([]);
  const [selectedReport, setSelectedReport] = useState(null);

  console.log(selectedReport?.data?.viewTypes,'selectedReportselectedReport')
  const [currentLevelIndex, setCurrentLevelIndex] = useState(0);
  const [levelStack, setLevelStack] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showIndividual, setShowIndividual] = useState(false);
  const [filterData, setFilterData] = useState(null);

  useEffect(() => {
    props.setBreadcrumbItems("Compliance Page", []);
  }, []);
const user = useSelector((state) => state?.users.users)
useEffect(() => {
  console.log("Redux user object:", user);
}, [user]);
  const getReportList = async () => {
  setLoading(true);
  try {
    const response = await axiosInstance.post(ApiNames.CUSTOM_REPORT_NAME_LIST);
    if (response.status) {
      const allReports = response.data.data;

     
     

      const userRole = user.userType || '';          // instead of user.role
      const userBranchId = user.orgId || '';         // instead of user.branchId
      const userBranchName = '';                     // not available in object

      console.log("Logged-in role:", userRole);
      console.log("User branch name:", userBranchName);
      console.log("User branch ID:", userBranchId);
      if (userRole === USERTYPES.Admin) {
      console.log("SuperAdmin detected, showing all reports");
      setReportsData(allReports);
      return; // ← important to exit early
      }

      const visibleReports = allReports.filter(report => {
        console.log("\nEvaluating report:", report.reportName);
        console.log("Assign To:", report.assignTo);
        console.log("Assigned Orgs:", report.assignedOrganizations);


        if (report.assignTo === 'everyone') {
          console.log("→ Visible (assigned to everyone)");
          return true;
        }

        if (report.assignTo === 'organization') {
          const assignedOrgs = report.assignedOrganizations || [];

          const match = assignedOrgs.some(org =>
          String(org.id).trim() === String(userBranchId).trim()
          );




          console.log("→ Visible (organization match):", match);
          return match;
        }

        if ([USERTYPES.Admin, USERTYPES.Global].includes(userRole)) {
          console.log("→ Visible (Admin override)");
          return true;
        }

        console.log("→ Not visible");
        return false;
      });

      const cleanedReports = visibleReports.filter(r => r && r.reportName);
      console.log("\nFinal visible reports:", cleanedReports.map(r => r.reportName));
      setReportsData(cleanedReports);
    }
  } catch (e) {
    console.error("Error loading reports:", e);
  } finally {
    setLoading(false);
  }
};




  useEffect(() => {
    getReportList();
  }, []);

  const getCurrentLevelKey = () => fallbackOrder[currentLevelIndex];

  const getNextAvailableLevel = (data, startIdx) => {
    for (let i = startIdx; i < fallbackOrder.length; i++) {
      const key = fallbackOrder[i];
      if (data[key] && data[key].length > 0) {
        return { key, items: data[key], index: i };
      }
    }
    return { key: '', items: [], index: -1 };
  };

  const handleReportClick = (report) => {
    const { key, items, index } = getNextAvailableLevel(report, 0);
    setSelectedReport({ data: report, currentItems: items, currentKey: key });
    setCurrentLevelIndex(index);
    setLevelStack([{ key, index }]);
  };

const handleItemClick = (itemValue) => {
  const { data } = selectedReport;
  const updatedStack = [...levelStack];
  updatedStack[updatedStack.length - 1].value = itemValue;

  const nextLevel = getNextAvailableLevel(data, currentLevelIndex + 1);

  if (nextLevel.items.length > 0) {
    // Move to next level
    setSelectedReport({
      data,
      currentItems: nextLevel.items,
      currentKey: nextLevel.key
    });
    setCurrentLevelIndex(nextLevel.index);
    setLevelStack([...updatedStack, { key: nextLevel.key, index: nextLevel.index, value: null }]);
  } else {
    // Last level reached → open IndividualReports with all selected filter values
    const finalStack = [...updatedStack];
    const filterObj = {
      scanId,
      scanName: '',
      category: '',
      scanSubcat: '',
      scanGroup: '',
      areaName: ''
    };

    finalStack.forEach(({ key, value }) => {
      if (key && value) filterObj[key] = value;
    });

    setFilterData(filterObj);
    setShowIndividual(true);
  }
};

  const handleBack = () => {
    if (levelStack.length <= 1) {
      setSelectedReport(null);
      setLevelStack([]);
      setCurrentLevelIndex(0);
    } else {
      const updatedStack = [...levelStack];
      updatedStack.pop();
      const last = updatedStack[updatedStack.length - 1];
      const key = last.key;
      const items = selectedReport.data[key];
      setSelectedReport({ ...selectedReport, currentItems: items, currentKey: key });
      setCurrentLevelIndex(last.index);
      setLevelStack(updatedStack);
    }
  };

return (
  <React.Fragment>
    {showIndividual ? (
      <IndividualReports filterData={filterData} scanId={scanId} viewTypes={selectedReport?.data?.viewTypes} onBack={() => setShowIndividual(false)} />
    ) : (
      <Row className="justify-center">
        <Col lg={12}>
          <Card>
            <CardBody>
              {loading ? (
                <h4>Loading...</h4>
              ) : (
                <>
                  {!selectedReport ? (
                    <>
                      <h4 className="mb-3">Reports</h4>
                      
                      {reportsData.map((data, index) => (
                        <Alert
                          key={index}
                          color="dark"
                          onClick={() => handleReportClick(data)}
                          style={{ cursor: 'pointer' }}
                        >
                          {data.reportName}
                        </Alert>
                      ))}
                    </>
                  ) : (
                    <>
                      <div className="d-flex justify-content-between align-items-center mb-2">
                       <h5 className="mb-0">Report: {selectedReport.data.reportName}</h5>
                       <Button color="secondary" onClick={handleBack}>
                       ← Back
                        </Button>
                       </div>



                      <h6 className="mb-2">{selectedReport.currentKey}</h6>
                      {selectedReport.currentItems.map((item, i) => (
                        <Alert key={i} color="info" onClick={() => handleItemClick(item)} style={{ cursor: 'pointer' }}>
                          {item}
                        </Alert>
                      ))}

                      {selectedReport.currentItems.length === 0 && (
                        <Alert color="warning">No further data found in this report.</Alert>
                      )}
                    </>
                  )}
                </>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    )}
  </React.Fragment>
);

};

export default connect(null, { setBreadcrumbItems })(CustomerDashboard);
